import { useRef, useState } from 'react';
// material
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  TableCell,
  Typography
} from '@mui/material';

import PropTypes from 'prop-types';

import MenuPopover from '../MenuPopover';

// ----------------------------------------------------------------------

UserMoreInfo.propTypes = {
  user: PropTypes.object,
  club: PropTypes.string,
  status: PropTypes.string,
  level: PropTypes.string
};

export default function UserMoreInfo({ user, club, status, level }) {
  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TableCell component="th" scope="row" onClick={() => setIsOpen(true)} ref={ref}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={user.name} src={user.userImage} />
          <Typography variant="subtitle2" noWrap>
            {user.name}
          </Typography>
        </Stack>
      </TableCell>

      <TableCell ref={ref} align="left" onClick={() => setIsOpen(true)}>
        {user.prenom}
      </TableCell>

      <MenuPopover
        open={isOpen}
        onClose={() => setIsOpen(false)}
        anchorEl={ref.current}
        sx={{ width: 400 }}
      >
        <Card sx={{ display: 'flex' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography component="div" variant="h5">
                {`${user.prenom} ${user.name}`}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {user.email}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {user.phone}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {user.adresse}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {user.adresseSuite}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {`${user.ville ? user.ville : ''} - ${
                  user.codePostal && user.codePostal !== 0 ? user.codePostal : ''
                }`}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {level}
              </Typography>
              <Divider />
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {`${club} - ${status}`}
              </Typography>
            </CardContent>
          </Box>
        </Card>
      </MenuPopover>
    </>
  );
}
